import styled from "styled-components";

export const OverlayFooterTypes = {SHADOW: "shadow", BORDER: "border"}

const Wrapper = styled.div`
    z-index: 1000;
    position: sticky;
    bottom: 0;
    background-color: var(--wp--preset--color--white-shade);
    padding: var(--fits--vertical-padding) var(--fits--horizontal-padding);
    border-top: ${({$type}) => $type === OverlayFooterTypes.BORDER ? "1px solid var(--wp--preset--color--steel-grey-200, #F0F1F3)" : ""};
    box-shadow: ${({$type}) => $type === OverlayFooterTypes.SHADOW ? "18px 0px 36px 0px rgba(105, 109, 112, 0.05), 10px 0px 20px 0px rgba(105, 109, 112, 0.06), 6px 0px 8px 0px rgba(105, 109, 112, 0.07), 2px 0px 4px 0px rgba(105, 109, 112, 0.09), 0px 0px 2px 0px rgba(105, 109, 112, 0.11)" : ""};
`
const ButtonsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export function OverlayFooter({children, type = OverlayFooterTypes.BORDER}) {
    return (
        <Wrapper $type={type}>
            <ButtonsWrapper>{children}</ButtonsWrapper>
        </Wrapper>
    );
}
